<template>
    <div>
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">
                <a class="navbar-item" href="/dashboard">
                    <img src="/img/logo.png">
                </a>

                <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" @click="isOpen = !isOpen" v-bind:class="{'is-active': isOpen}">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div id="navbar-logged-in" class="navbar-menu" v-bind:class="{'is-active': isOpen}">
                <div class="navbar-start">
                    <router-link to="/records">
                        <a class="navbar-item">Records</a>
                    </router-link>
                    <router-link to="/dashboard">
                        <a class="navbar-item">Search</a>
                    </router-link>
                    <router-link v-if="this.$store.getters.isAdmin" to="/admin">
                        <a class="navbar-item">Admin</a>
                    </router-link>
                </div>

                <div class="navbar-end">
                    <div class="navbar-item">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                {{default_location}}
                            </a>

                            <div class="navbar-dropdown">
                                <a v-for="location in this.locations" class="navbar-item" @click="setDefaultLocation(location.id)">
                                        {{location.location}}
                                </a>

                            </div>
                        </div>
                    </div>
                    <div class="navbar-item">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <a class="navbar-link">
                                {{name}}
                            </a>

                            <div class="navbar-dropdown">
                                <a class="navbar-item">
                                    <router-link to="profile">
                                        Profile
                                    </router-link>
                                </a>
                                <a class="navbar-item" @click="logout">
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <hr class="nav-border">
    </div>
</template>

<script>
    export default {
        name: "Navbar",
        data: function() {
            return {
                isOpen: false
            }
        },
        computed: {
            name (){
                return this.$store.state.user.name
            },
            locations() {
                return this.$store.state.user.locations
            },
            default_location(){
                return this.$store.getters.default_location_name
            },
        },
        methods: {
            logout() {

                this.$store.dispatch('logout')
                    .then(() => this.$router.push('/login'))
                    .catch(err => console.log(err))
            },
            setDefaultLocation(id)
            {
                this.$store.commit('set_default_location',id);
                this.$router.go();
            }
        },
    }
</script>

<style scoped>
    .navbar-menu {
        padding-top: 15px;
    }
    hr.nav-border {
        background-color: #eeebe6;
        width: 120%;
        height: 12px;
        border-top: 1px solid #cfccc6;
        border-bottom: 1px solid #cfccc6;
    }
</style>